/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FaceASadIcon32Regular = forwardRef('FaceASadIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M11.01 21.36c.569-1.908 2.614-3.385 4.99-3.385 2.375 0 4.42 1.477 4.99 3.384a1 1 0 1 0 1.916-.572c-.856-2.87-3.773-4.812-6.906-4.812-3.134 0-6.05 1.942-6.907 4.812a1 1 0 1 0 1.916.572Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3ZM5 16C5 9.925 9.925 5 16 5s11 4.925 11 11-4.925 11-11 11S5 22.075 5 16Z" })));
});
